import GuidedTour from "../GuidedTour";
import { StepType } from "@reactour/tour";

export const ResultSteps: StepType[] = [
  {
    selector: ".Result .campaign-overview",
    position: "right",
    content: (
      <GuidedTour
        title="Data-Analytics and Connect with Candidates Through Profile Links "
        content="Discover in-depth metrics for your campaign, providing valuable insights into its performance. Track the time remaining for your recruitment efforts, monitor the completion status of goals, and visualize the cumulative budget against profiles selected through detailed graphs. Additionally, stay informed about the total number of profiles reviewed, helping you make data-driven decisions and optimize your recruitment strategy.."
      />
    ),
  },
  {
    selector: ".Result .scatter-group",
    position: "right",
    content: (
      <GuidedTour
        title="Data-Analytics and Connect with Candidates Through Profile Links "
        content="Scatter charts provide insights into candidates' strengths. Analyzing HEPPAI's clusters helps you make informed hiring decisions and identify suitable candidates, including outliers."
      />
    ),
  },
  {
    selector: ".Result .CandidateTable",
    position: "right",
    content: (
      <GuidedTour
        title="Data-Analytics and Connect with Candidates Through Profile Links "
        content="HEPPAI matches suitable candidates to your needs, allowing access to profiles from various platforms for easier contact. Public information can also be enriched with additional details on demand."
      />
    ),
  },
];
